export default __webpack_public_path__ + "static/media/ev-illustration.886597a8.svg";